import './dropdown.scss';

class DropdownDirective {
    constructor($document, $rootScope, $window) {
        this.restrict = 'A';
        this.$document = $document;
        this.$rootScope = $rootScope;
        this.$window = $window;
    }

    link(scope, element, attrs, controllers) {
        const targetId = attrs.targetId;
        const fallbackUrl = attrs.fallbackUrl || null;
        const triggers = attrs.triggers || 'click';
        const supportsMatchMedia = this.$window.matchMedia !== undefined && !!this.$window.matchMedia('all').addListener;
        const parent = element.parent();
        
        if (!targetId || targetId == '') {
            console.error('DropdownDirective::noTarget');
            return;
        }

        const target = document.getElementById(targetId);

        if (!target) return;

        const $target = angular.element(target);

        $target.removeClass('open');
        element.removeClass('dropdown-open');

        let isOpen = false;

        const isMobile = () => supportsMatchMedia && this.$window.matchMedia("(max-width: 960px)").matches;

        const openOnClick = (e) => {
            if (triggers.indexOf('click') < 0 && !isMobile()) return;

            e.stopPropagation();

            if (isMobile() && fallbackUrl) {
                this.$window.location.href = fallbackUrl;
                return;
            }
            
            if (isMobile() && !isOpen) {
                e.preventDefault();
            }

            $target.toggleClass('open');
            element.toggleClass('dropdown-open');
            isOpen = !isOpen;

            if (!isOpen) return;

            this.$rootScope.$broadcast('dropdown-open', targetId);
        };

        element.on('click', openOnClick);

        const openOnMouseEnter = (e) => {
            if (triggers.indexOf('mouseenter') < 0) return;

            if (isMobile()) return;

            if (isOpen) return;

            e.stopPropagation();
            
            $target.addClass('open');
            element.addClass('dropdown-open');
            isOpen = true;

            this.$rootScope.$broadcast('dropdown-open', targetId);
        };

        const hideOnMouseLeave = (e) => {
            if (triggers.indexOf('mouseenter') < 0) return;

            if (isMobile()) return;

            if (!isOpen)
                return;

            $target.removeClass('open');
            element.removeClass('dropdown-open');
            isOpen = false;
        };
        
        element.on('mouseenter', openOnMouseEnter);
        parent.on('mouseleave', hideOnMouseLeave);

        const documentClickOutside = (e) => {
            if (!isOpen)
                return;

            if (element !== e.target && $target !== e.target && !$target[0].contains(e.target)) {
                $target.removeClass('open');
                element.removeClass('dropdown-open');
                isOpen = false;
            }
        };

        this.$document.on('click', documentClickOutside);

        this.$rootScope.$on('dropdown-open', function(event, id) {
            if (targetId === id) return;

            $target.removeClass('open');
            element.removeClass('dropdown-open');
            isOpen = false;
        });

        scope.$on('$destroy', () => {
            element.on('click', openOnClick);
            element.off('mouseenter', openOnMouseEnter);
            parent.off('mouseleave', hideOnMouseLeave);
            this.$document.off('click', documentClickOutside);
        });
    }

    static directiveFactory($document, $rootScope, $window) {
        'ngInject';
        return new DropdownDirective($document, $rootScope, $window);
    }
}

export default DropdownDirective;